// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".personal{padding:0!important}.quickNewDropdown .popper__arrow{display:none!important}", ""]);
// Exports
module.exports = exports;
